import { exists } from "shared/lib/exists"

export function comparePosition<T extends { position: number }>(
  itemA: T,
  itemB: T
) {
  return (
    (exists(itemA.position) ? itemA.position : Infinity) -
    (exists(itemB.position) ? itemB.position : Infinity)
  )
}
